<div id="coaching-type-filter">
    <cxone-singleselect-dropdown id="coaching-dropdown" [(ngModel)]="selectedFilter" [options]="coachDropDownOptions"
        placeholder={{placeholder}} [primaryKey]="'id'" [label]="'name'" [sortKey]="'id'" [isRequired]="false"
        [showFooter]="false" [search]="false" (ngModelChange)="coachingTypeSelect(true)">
    </cxone-singleselect-dropdown>
</div>
